import { combineReducers } from 'redux';

import history from './delegationHistoryReducer';
import filters from './delegationFiltersReducer';
import pagination from './delegationPaginationReducer';
import navBar from './navBarReducer';
import leftNavParams from './leftNavReducer';

export default combineReducers ({
    history,
    filters,
    pagination,
    navBar,
    leftNavParams
});